import ApiClientAccount from './apiClientAccount'
import { useAuthStore } from './authStore'

// Vytvoríme jedinú inštanciu ApiClientAccount pre celú aplikáciu
const apiClientAccount = new ApiClientAccount()

// Pri prvom načítaní aplikácie nastavíme token z `authStore`
const auth = useAuthStore.getState().auth
apiClientAccount.setAuthToken(auth?.token ?? null)

// Počúvame na zmeny v `authStore` a aktualizujeme `apiClientAccount`
useAuthStore.subscribe((state) => {
  apiClientAccount.setAuthToken(state.auth?.token ?? null)
})

/**
 * Hook to get the api instance (Nest /account doc, apiClientAccount).
 * Synchronizuje token zo store pri každom renderi, čím sa vyhne race condition
 * keď hasAuthToken je už true, ale client ešte nemal token.
 */
export function useApiClientAccount() {
  const auth = useAuthStore((state) => state.auth)
  // Sync token pred vrátením - zaručí, že client má token keď ho komponent použije
  apiClientAccount.setAuthToken(auth?.token ?? null)
  return apiClientAccount.apiInstance
}
